import React from "react";
var __jsx = React.createElement;
import { useMemo } from "react";
import { Drawer } from "vaul";
import { DrawerPortal } from "@/components/Drawer";
import { Dialog, DialogContent } from "@/components/Dialog";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Then } from "@componentsShared/Conditional/Then";
import { Else } from "@componentsShared/Conditional/Else";
import useIsMobile from "@hooks/useIsMobile";
import { useLang } from "@/common/Contexts/LanguageContext";
import SellCarSteps from "./SellCarSteps";
import FAQSection from "./FAQSection";
import arData from "@data/landing-pages/sell-trade-v3/ar.json";
import enData from "@data/landing-pages/sell-trade-v3/en.json";
var StepsAndFAQModal = function StepsAndFAQModal(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose;
  var isMobile = useIsMobile();
  var lang = useLang();

  // Get data based on language
  var cmsData = useMemo(function () {
    var data = lang === "ar" ? arData : enData;
    return data;
  }, [lang]);

  // Extract data from CMS response
  var sellCarStepsData = useMemo(function () {
    if (!(cmsData !== null && cmsData !== void 0 && cmsData.contentSections)) return null;
    var data = cmsData.contentSections.find(function (comp) {
      return comp.__component === "shared.placeholder" && comp.component_type === "sell_trade_steps";
    });
    return data;
  }, [cmsData]);
  var faqData = useMemo(function () {
    if (!(cmsData !== null && cmsData !== void 0 && cmsData.contentSections)) return null;
    var data = cmsData.contentSections.find(function (comp) {
      return comp.__component === "shared.faq-list";
    });
    return data;
  }, [cmsData]);
  var modalContent = /*#__PURE__*/React.createElement("div", {
    className: "max-h-[80vh] overflow-y-auto py-4 [&::-webkit-scrollbar]:hidden",
    style: {
      scrollbarWidth: 'none',
      msOverflowStyle: 'none'
    }
  }, sellCarStepsData ? /*#__PURE__*/React.createElement(SellCarSteps, {
    data: sellCarStepsData
  }) : /*#__PURE__*/React.createElement("div", null, "No steps data"), faqData ? /*#__PURE__*/React.createElement(FAQSection, {
    data: faqData
  }) : /*#__PURE__*/React.createElement("div", null, "No FAQ data"));
  return /*#__PURE__*/React.createElement(Conditional, {
    condition: isMobile
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(Drawer.Root, {
    open: isOpen,
    onOpenChange: function onOpenChange(open) {
      return !open && onClose();
    },
    onClose: onClose
  }, /*#__PURE__*/React.createElement(DrawerPortal, null, /*#__PURE__*/React.createElement(Drawer.Overlay, {
    className: "fixed inset-0 bg-[#071425] opacity-80 z-[9998]"
  }), /*#__PURE__*/React.createElement(Drawer.Content, {
    className: "bg-white flex flex-col rounded-t-[10px] fixed bottom-0 left-0 right-0 z-[9999] py-4 px-6 max-h-[90vh]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-12 h-1.5 bg-gray-300 rounded-full mx-auto mb-4"
  }), /*#__PURE__*/React.createElement("div", {
    className: "absolute right-4 en:left-4 top-4 text-2xl text-gray-500 hover:text-gray-700",
    onClick: onClose
  }), modalContent)))), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement(Dialog, {
    open: isOpen,
    onOpenChange: function onOpenChange(open) {
      return !open && onClose();
    }
  }, /*#__PURE__*/React.createElement(DialogContent, {
    className: "max-w-[1200px] p-6 z-[100000]",
    haveClose: true,
    overlayClassName: "z-[10000]"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full sticky top-0 h-6 bg-white"
  }), /*#__PURE__*/React.createElement("div", null, modalContent)))));
};
export default StepsAndFAQModal;